import api from './api';

const paymentMethodMasterService = {
  getAllPaymentMethods: async (params = {}) => {
    try {
      const response = await api.get('/payment-method-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all payment method master records:', error);
      throw error;
    }
  },

  getPaymentMethodById: async (id) => {
    try {
      const response = await api.get(`/payment-method-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching payment method master record with ID ${id}:`, error);
      throw error;
    }
  },

  getNextPaymentMethodCode: async () => {
    try {
      const response = await api.get('/payment-method-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next payment method code:', error);
      throw error;
    }
  },

  createPaymentMethod: async (paymentMethodData) => {
    try {
      const response = await api.post('/payment-method-master', paymentMethodData);
      return response.data;
    } catch (error) {
      console.error('Error creating payment method master record:', error);
      throw error;
    }
  },

  updatePaymentMethod: async (id, paymentMethodData) => {
    try {
      const response = await api.put(`/payment-method-master/${id}`, paymentMethodData);
      return response.data;
    } catch (error) {
      console.error(`Error updating payment method master record with ID ${id}:`, error);
      throw error;
    }
  },

  deletePaymentMethod: async (id) => {
    try {
      const response = await api.delete(`/payment-method-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting payment method master record with ID ${id}:`, error);
      throw error;
    }
  },

  getPaymentMethodStats: async () => {
    try {
      const response = await api.get('/payment-method-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching payment method master stats:', error);
      throw error;
    }
  },

  getActivePaymentMethods: async () => {
    try {
      const response = await api.get('/payment-method-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active payment methods:', error);
      throw error;
    }
  },
};

export default paymentMethodMasterService;

